import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["earlyRequest"];
import quickFetch from 'quick-fetch';
import { getAvroGateway, parseRejectingChirpErrors } from './chirp-avro';
import { createRequestName } from './quick-fetch-utils';

/**
 * Makes a chirp early request using quick-fetch.
 *
 * This REQUIRES the details object from `/earlyRequest/{SERVICE}.early.ts for tree shaking purposes.
 *
 * To receive this data, use the normal details object in a call. If the data is ready, it will be returtned.
 */
export const makeChirpEarlyRequest = (details, inputs) => {
  const {
    request
  } = inputs;
  const {
    auth,
    serviceName,
    rpcName,
    fingerprint,
    isLocal
  } = details;
  const detailsCopyWithoutEarlyRequest = _objectWithoutPropertiesLoose(details, _excluded);
  const requestName = createRequestName(detailsCopyWithoutEarlyRequest, request);
  const endpointUrlBase = isLocal ? getAvroGateway({
    auth,
    isLocal,
    timeout: 5000
  }) : `${quickFetch.getApiUrl(getAvroGateway({
    auth,
    timeout: 5000
  }))}`;
  const endpointUrl = `${endpointUrlBase}/${serviceName}/${rpcName}`;
  return new Promise((resolve, reject) => {
    quickFetch.makeEarlyRequest(requestName, {
      type: 'POST',
      data: JSON.stringify(request !== null && request !== void 0 ? request : {}),
      extraHeaders: [{
        header: 'x-hs-fingerprint',
        value: fingerprint
      }],
      url: endpointUrl,
      timeout: 5000,
      whenFinished: response => {
        try {
          const parsed = JSON.parse(response);
          const result = parseRejectingChirpErrors(parsed);
          resolve(result);
        } catch (e) {
          reject(e);
        }
      },
      onError: (xhr, __errorMessage) => {
        try {
          const parsed = JSON.parse(xhr.responseText);
          parseRejectingChirpErrors(parsed);
        } catch (e) {
          reject(e);
        }
      }
    });
  });
};
export const getChirpEarlyRequestName = (details, inputs) => {
  var _inputs$request;
  const request = (_inputs$request = inputs === null || inputs === void 0 ? void 0 : inputs.request) !== null && _inputs$request !== void 0 ? _inputs$request : {};
  return createRequestName(details, request);
};
export const getChirpEarlyRequest = ({
  details,
  requestObject
}) => {
  var _requestObject$reques;
  const request = (_requestObject$reques = requestObject === null || requestObject === void 0 ? void 0 : requestObject.request) !== null && _requestObject$reques !== void 0 ? _requestObject$reques : {};
  const requestName = createRequestName(details, request);
  const requestState = quickFetch.getRequestStateByName(requestName);
  if (requestState && !requestState.error) {
    return new Promise((resolve, reject) => {
      requestState.whenFinished(response => {
        quickFetch.removeEarlyRequest(requestName);
        // Quick fetch responses are always strings
        resolve(JSON.parse(response));
      });
      requestState.onError((xhr, errorMessage) => {
        quickFetch.removeEarlyRequest(requestName);
        try {
          const parsed = JSON.parse(xhr.responseText);
          if (typeof parsed === 'object' && (parsed.type === 'rpcError' || parsed.type === 'internalError')) {
            resolve(parsed);
          } else {
            reject(errorMessage);
          }
        } catch (e) {
          reject(errorMessage);
        }
      });
    });
  }
  return undefined;
};